<div class="calc">
  <div class="calc-display" [style.fontSize.px]="displayFontPx()">{{ displayText() }}</div>
  <div class="calc-grid">
    <button class="calc-btn fn" (click)="clearAll()">AC</button>
    <button class="calc-btn fn" (click)="negate()">±</button>
    <button class="calc-btn fn" (click)="percent()">%</button>
    <button class="calc-btn op" [class.on]="activeOp() === '÷'" (click)="chooseOp('÷')">÷</button>

    <button class="calc-btn" (click)="inputDigit('7')">7</button>
    <button class="calc-btn" (click)="inputDigit('8')">8</button>
    <button class="calc-btn" (click)="inputDigit('9')">9</button>
    <button class="calc-btn op" [class.on]="activeOp() === '×'" (click)="chooseOp('×')">×</button>

    <button class="calc-btn" (click)="inputDigit('4')">4</button>
    <button class="calc-btn" (click)="inputDigit('5')">5</button>
    <button class="calc-btn" (click)="inputDigit('6')">6</button>
    <button class="calc-btn op" [class.on]="activeOp() === '−'" (click)="chooseOp('−')">−</button>

    <button class="calc-btn" (click)="inputDigit('1')">1</button>
    <button class="calc-btn" (click)="inputDigit('2')">2</button>
    <button class="calc-btn" (click)="inputDigit('3')">3</button>
    <button class="calc-btn op" [class.on]="activeOp() === '+'" (click)="chooseOp('+')">+</button>

    <button class="calc-btn zero" (click)="inputDigit('0')">0</button>
    <button class="calc-btn" (click)="inputDigit('.')">.</button>
    <button class="calc-btn eq" (click)="equals()">=</button>
  </div>
</div>
